require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[72],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

module.exports = require("react-measure");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(591);


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _TruncatedText = _interopRequireDefault(__webpack_require__(592));

exports["default"] = _TruncatedText["default"];
exports.TruncatedText = _TruncatedText["default"];

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactMeasure = _interopRequireDefault(__webpack_require__(32));

var _utils = __webpack_require__(4);

var _lodash = __webpack_require__(20);

var _TruncatedText = _interopRequireDefault(__webpack_require__(593));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui--carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var truncatedTextClassName = _TruncatedText["default"].truncatedTextClassName.replace(/"/g, '');

var CHAR_THRESHOLD = 4;
var sanitize = _utils.propsUtils.sanitize,
    BaPropTypes = _utils.propsUtils.BaPropTypes;
var resolveBaseTextDir = _utils.bidiUtils.resolveBaseTextDir;

var TruncatedText = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TruncatedText, _Component);

  function TruncatedText(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      charCount: _this._handleValueType().length
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMeasure", function (dimensions) {
      if (_this.state.isMounted) {
        var containerWidth = Math.ceil(dimensions.entry.width);

        _this._resizeText(containerWidth);
      } else {
        _this._getTextWidths();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getTextWidths", function () {
      var value = _this._handleValueType(); // get initial widths and char counts


      if (_this._textNode) {
        _this._textWidth = _this._textNode.offsetWidth;
        _this._initTextWidth = _this._textNode.offsetWidth;
        _this._initCharCount = value.length;
        _this._initCharWidth = _this._getCharWidth(value.length);
        _this._lastTruncPos = _this._initTextWidth;

        _this.setState({
          isMounted: true
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (node) {
      _this._node = node;

      _this._measureRef(node);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_refText", function (node) {
      _this._textNode = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getTextNode", function () {
      var _this$props = _this.props,
          title = _this$props.title,
          textDir = _this$props.textDir,
          allowTooltip = _this$props.allowTooltip;

      var value = _this._handleValueType();

      var charCount = _this.state.charCount;
      var initCharCount = value.length;
      var isEllipsed = charCount >= 0 && charCount < initCharCount;
      var ellipsisValue = '';

      if (isEllipsed) {
        if (charCount <= 1) {
          ellipsisValue = "\u2026";
        } else {
          var charStart = Math.floor(charCount / 2);
          var charEnd = initCharCount - Math.ceil(charCount / 2) + 1;
          ellipsisValue = _this.props.location === 'middle' ? value.substring(0, charStart) + "\u2026" + value.substring(charEnd) : value.substring(0, charCount - 3) + "\u2026";
        }
      } else {
        ellipsisValue = _utils.Bidi.reshape(value, _this.props.numShape);
      }

      var mappedTitle = function mappedTitle() {
        var titleStr = allowTooltip && isEllipsed && (title || value);
        return titleStr ? {
          title: titleStr
        } : {};
      };

      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
        "data-tid": "ba-common-truncated-text__text-node",
        className: "" + (0, _utils.classnames)(truncatedTextClassName + "__text"),
        ref: _this._refText,
        "aria-label": title || value,
        dir: resolveBaseTextDir(ellipsisValue, textDir, false)
      }, mappedTitle()), ellipsisValue);
    });
    _this.debouncedResizeText = (0, _lodash.debounce)(_this._resizeText, 10);
    return _this;
  }

  var _proto = TruncatedText.prototype;

  _proto.componentDidMount = function componentDidMount() {
    // Defect 234641: Added._textNode.offsetWidth condition check to prevent truncated text with 0 max width
    if (!this._textNode.offsetWidth) {
      setTimeout(this._getTextWidths);
    } else {
      this._textNode && this._getTextWidths();
    }
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      // reset charCount to trigger measuring again
      var nextValueProp = this._handleValueType(nextProps.value);

      this.setState({
        charCount: nextValueProp.length,
        isMounted: false
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.state.isMounted) {
      var containerWidth = this._node.offsetWidth;
      this._textWidth = this._textNode.offsetWidth;

      if (prevState.isMounted !== this.state.isMounted) {
        // check if resizing is still needed after first render
        this.debouncedResizeText(containerWidth);
      } else if (prevState.charCount !== this.state.charCount) {
        // keep track of position when last truncation was made
        this._lastTruncPos = containerWidth;

        if (containerWidth < this._textWidth) {
          // keep resizing until textWidth is < container
          this._shortenText(containerWidth);
        }
      }
    } else if (prevProps.value !== this.props.value) {
      // trigger measuring after updating props (i.e. in Select)
      this._getTextWidths();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.debouncedResizeText && this.debouncedResizeText.cancel();
  };

  _proto._handleValueType = function _handleValueType(value) {
    if (value === void 0) {
      value = this.props.value;
    }

    return value == null ? '' : String(value);
  };

  _proto._resizeText = function _resizeText(containerWidth) {
    if (containerWidth < this._textWidth && containerWidth < this._lastTruncPos) {
      this._shortenText(containerWidth);
    } else if (containerWidth > this._textWidth && containerWidth < this._initTextWidth && containerWidth > this._lastTruncPos) {
      this._lengthenText(containerWidth);
    } else if (containerWidth >= this._initTextWidth && this.state.charCount !== this._initCharCount) {
      // show entire string by resetting charCount
      this._lastTruncPos = this._initTextWidth;
      this.setState({
        charCount: this._initCharCount
      });
    }
  };

  _proto._shortenText = function _shortenText(containerWidth) {
    var charCount = this.state.charCount;

    if (charCount > 0 && containerWidth > 0) {
      var charWidth = this._getCharWidth(charCount);

      var extraChars = this._getExcessChars(containerWidth, charWidth);

      var newCharCount = Math.max(0, charCount - Math.max(1, extraChars));
      this.setState({
        charCount: newCharCount
      });
    }
  };

  _proto._lengthenText = function _lengthenText(containerWidth) {
    var value = this._handleValueType();

    var charCount = this.state.charCount;

    if (charCount < value.length) {
      var charWidth = this._getCharWidth(charCount);

      var diff = containerWidth - this._textWidth;

      var missingChars = this._getExcessChars(containerWidth, charWidth);

      if (diff > 1.5 * charWidth || value.length - charCount === 1) {
        var newCharCount = Math.min(value.length, charCount + missingChars);

        if (newCharCount !== charCount) {
          this.setState({
            charCount: newCharCount
          });
        }
      }
    }
  };

  _proto._getCharWidth = function _getCharWidth(charCount) {
    return charCount > CHAR_THRESHOLD ? this._textWidth / charCount : this._initCharWidth;
  };

  _proto._getExcessChars = function _getExcessChars(containerWidth, charWidth) {
    var extraChars = Math.floor((this._textWidth - containerWidth) / charWidth);
    return Math.abs(extraChars);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        className = _this$props2.className,
        textAlign = _this$props2.textAlign,
        style = _this$props2.style,
        disabled = _this$props2.disabled,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["className", "textAlign", "style", "disabled"]);
    var isMounted = this.state.isMounted;
    var containerStyle = (0, _extends2["default"])({
      textAlign: textAlign,
      // Defect 226704: Added the fallback inline styles
      // Defect 234641: Added _initTextWidth as part of condition check
      maxWidth: isMounted && this._initTextWidth !== 0 ? this._initTextWidth + 2 : '100%',
      display: isMounted ? 'table' : 'block'
    }, style);
    var classNames = (0, _utils.classnames)(truncatedTextClassName, {
      disabled: disabled
    });
    return /*#__PURE__*/_react["default"].createElement(_reactMeasure["default"], {
      onResize: this.onMeasure
    }, function (_ref) {
      var measureRef = _ref.measureRef;
      _this2._measureRef = measureRef;
      return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, TruncatedText), {
        className: classNames + " " + className,
        ref: _this2._ref,
        style: (0, _extends2["default"])({}, containerStyle)
      }), _this2.getTextNode());
    });
  };

  return TruncatedText;
}(_react.Component);

exports["default"] = TruncatedText;
(0, _defineProperty2["default"])(TruncatedText, "propTypes", {
  value: _propTypes["default"].string.isRequired,
  location: _propTypes["default"].oneOf(['end', 'middle']),
  textAlign: _propTypes["default"].oneOf(['left', 'right', 'center']),
  title: _propTypes["default"].string,
  className: _propTypes["default"].string,
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto']),
  numShape: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  disabled: _propTypes["default"].bool,
  allowTooltip: _propTypes["default"].bool,
  tooltipDelay: BaPropTypes.deprecated('deprecated - browser tooltip is used ')
});
(0, _defineProperty2["default"])(TruncatedText, "defaultProps", {
  location: 'middle',
  className: '',
  style: {},
  allowTooltip: true
});

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(594);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-truncatedText{overflow:hidden;white-space:nowrap;width:100%;display:table;table-layout:fixed;text-decoration:inherit}.ba-common-truncatedText__text{white-space:nowrap;line-height:normal;display:inline-block;text-decoration:inherit}.ba-common-truncatedText__tooltip{width:100%}.ba-common-truncatedText.is-disabled{cursor:not-allowed}.ba--highContrast .ba-common-truncatedText.is-disabled{cursor:not-allowed;text-decoration:line-through}.ba-common-truncatedText{transition:opacity .2s ease-in-out}.ba-common-truncatedText.is-disabled{opacity:.5}.test{font-size:50px;line-height:75px}\n", ""]);

// exports
exports.locals = {
	"truncatedTextClassName": "\"ba-common-truncatedText\""
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[590,0]]]);
});